module.exports = __webpack_public_path__ + "img/yellow_bird.54d190e1.jpg";